export class EmployeeDashboard {
    objectId: string;
    userProfileId: any;
    reportingTo: any;
    totalViolations: number;
    totalEscalations: number;
    totalLeaves: number;
    violations: any[];
    status: string;
}